export default __webpack_public_path__ + "static/media/grey-arrow.598fd161.svg";